export default __webpack_public_path__ + "static/media/misc-books1-2048w.dee1118c.webp";